import Api from '../api';
import {ADMIN_TENANT_NOTIFICATIONS_SEARCH_URL, NOTIFICATIONS_URL} from '../lib/constant';

// Plain promise calls (no store): the Email Templates page owns its state.
// Responses are protojson (lowerCamelCase); every call resolves to the body.

const body = ({data}) => data;
const kindPath = (kind) => `${NOTIFICATIONS_URL}/templates/${encodeURIComponent(kind)}`;

export const listTemplates = () => Api.get(`${NOTIFICATIONS_URL}/templates`).then(body);

export const getTemplate = (kind, version) =>
  Api.get(kindPath(kind), true, version ? {version} : {}).then(body);

export const saveDraft = (kind, {subject, mjmlSource, textSource, sampleDataJson}) =>
  Api.post(`${kindPath(kind)}/drafts`, {
    subject, mjmlSource, sampleDataJson, ...(textSource ? {textSource} : {})
  }).then(body);

// source: {version: n} or {draft: {subject, mjmlSource, textSource}}
export const previewTemplate = (kind, source, dataJson) =>
  Api.post(`${kindPath(kind)}/preview`, {...source, ...(dataJson ? {dataJson} : {})}).then(body);

export const sendTestEmail = (kind, version) =>
  Api.post(`${kindPath(kind)}/test`, {version}).then(body);

export const publishTemplate = (kind, version) =>
  Api.post(`${kindPath(kind)}/versions/${version}/publish`, {}).then(body);

export const getSettings = () => Api.get(`${NOTIFICATIONS_URL}/settings`).then(body);

export const updateSettings = ({sendingEnabled, dryRun, marketingDailyCap}) =>
  Api.put(`${NOTIFICATIONS_URL}/settings`, {sendingEnabled, dryRun, marketingDailyCap}).then(body);

// request: {filter: {kind?, status?, createdFrom?, createdTo?}, pageSize, pageOffset}
export const searchNotifications = (request) =>
  Api.post(`${NOTIFICATIONS_URL}/messages/search`, request).then(body);

export const searchOrgNotifications = (orgId, request) =>
  Api.post(ADMIN_TENANT_NOTIFICATIONS_SEARCH_URL.replace('{tenantId}', encodeURIComponent(orgId)), request).then(body);

export const listOptOuts = (pageSize, pageOffset) =>
  Api.get(`${NOTIFICATIONS_URL}/opt-outs`, true, {pageSize, pageOffset}).then(body);

export const removeOptOut = (email) =>
  Api.post(`${NOTIFICATIONS_URL}/opt-outs/remove`, {email}).then(body);
